import TemplateOne from "./TemplateOne";
import TemplateTwo from "./TemplateTwo";
import TemplateThree from "./TemplateThree";
import TemplateFour from "./TemplateFour";

const TableFactory = {
  TemplateOne: TemplateOne,
  TemplateTwo: TemplateTwo,
  TemplateThree: TemplateThree,
  TemplateFour: TemplateFour
};

export const getTemplate = (type) => {
  return TableFactory[type] || null;
};
